import React from "react";
import ReactDOM from "react-dom/client";
import CollapsibleSection from "../components/CollapsibleSection.jsx";
import './frontend.css';

document.querySelectorAll(".wp-block-bigsave-collapsible-section").forEach((div) => {
  const data = JSON.parse(div.querySelector("pre").innerText);
  const savedHTML = div.querySelector(".inner-content")?.innerHTML || "";
  div.innerHTML = ""; // Clear container before mounting React
  
  ReactDOM.createRoot(div).render(
    <CollapsibleSection
      header={<div className="cell-header">
        <div clasName="text">
          <h2>{data.headerTitle}</h2>
          <p dangerouslySetInnerHTML={{ __html: data.headerParagraph1 }} />
          <p dangerouslySetInnerHTML={{ __html: data.headerParagraph2 }} />
        </div>
      </div>}
      sectionName={data.headerTitle}
      defaultOpen={data.defaultOpen || false}
      arrowColour={data.arrowColour || "var(--wp--preset--color--bigsave-layout-border-colour)"}
    >
      <div dangerouslySetInnerHTML={{ __html: savedHTML }} />
    </CollapsibleSection>
  );
});